




























































import { GetServicesServiceNoMainDomainsResponse, Mall } from 'ncp-api-supporter';
import { Component, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import DomainSecurityConnectionMixin from './domainSecurityConnectionMixin';
import SslServerStatus from './SslServerStatus.vue';

type DomainSecurityRecommendation = {
  text: '필요' | '주의' | '완료';
  color: 'text-red' | 'text-orange' | 'text-green';
  icon: 'blocked' | 'warning' | 'completed';
};

@Component({
  components: {
    SslServerStatus,
  },
})
export default class DomainSecurityConnection extends DomainSecurityConnectionMixin {
  @Prop({ required: true })
  readonly selectMallNo!: '' | number;

  @Prop({ required: true })
  readonly domainSecurityInfo!: GetServicesServiceNoMainDomainsResponse;

  get isCombine() {
    return this.domainSecurityInfo.skinType === 'COMBINE';
  }

  @State('malls', { namespace: 'mall' })
  readonly malls!: Mall[];

  get mallName() {
    return this.malls.find(({ mallNo }) => this.selectMallNo === mallNo)?.mallName;
  }

  // 도메인/보안서버 연결상태 - 필요 | 주의 | 완료
  get domainSecurityRecommendation(): DomainSecurityRecommendation {
    const {
      domain,
      domainExpirationDueDays,
      domainStatus,
      mobileSslExpirationDueDays,
      mobileSslStatus,
      sslExpirationDueDays,
      sslStatus,
    } = this.domainSecurityInfo;

    const isUnConnect = !domain || domainStatus === 'EXPIRATION' || this.getIsSslUnConnect(sslStatus);
    const isConnect = domainStatus === 'CONNECTED' && sslStatus === 'INSTALLED';

    // CASE: '필요'
    if (
      (this.isCombine && isUnConnect) ||
      (!this.isCombine && (isUnConnect || this.getIsSslUnConnect(mobileSslStatus)))
    ) {
      return { text: '필요', color: 'text-red', icon: 'blocked' };
    }

    // CASE: '주의'
    if (
      this.getIsExpiredClose(domainExpirationDueDays) ||
      this.getIsExpiredClose(mobileSslExpirationDueDays) ||
      this.getIsExpiredClose(sslExpirationDueDays)
    ) {
      return { text: '주의', color: 'text-orange', icon: 'warning' };
    }

    // CASE: '완료'
    if ((this.isCombine && isConnect) || (!this.isCombine && isConnect && mobileSslStatus === 'INSTALLED')) {
      return { text: '완료', color: 'text-green', icon: 'completed' };
    }

    return { text: '필요', color: 'text-red', icon: 'blocked' };
  }
}
